document.addEventListener('DOMContentLoaded', () => {
  const forms = Array.from(document.querySelectorAll('.js-address-form'));

  /**
   *
   * @param {boolean} show - show
   * @param {HTMLDivElement} container - container
   */
  function toggleForm(show, container) {
    const el = container;

    if (show && el) {
      el.style.display = null;
    } else {
      el.style.display = 'none';
    }
  }

  /**
   *
   * @param {HTMLFormElement} form - Form
   */
  function handleChange(form) {
    const deliveryInfoCorporateEl = form.querySelector('.js-address-form-corporate');
    const deliveryInfoInvoiceAddressEl = form.querySelector('.js-address-form-invoice-address');
    const deliveryInfoAddressTitleEl = form.querySelector('.js-address-form-address-title');

    if (form.elements['delivery[invoiceType]'] && deliveryInfoCorporateEl) {
      toggleForm(
        form.elements['delivery[invoiceType]'].value === 'corporate',
        deliveryInfoCorporateEl,
      );
    }

    if (form.elements['delivery[same_address]'] && deliveryInfoInvoiceAddressEl) {
      toggleForm(form.elements['delivery[same_address]'].checked, deliveryInfoInvoiceAddressEl);
    }

    if (form.elements['delivery[save_address]'] && deliveryInfoAddressTitleEl) {
      toggleForm(form.elements['delivery[save_address]'].checked, deliveryInfoAddressTitleEl);
    }
  }

  forms.forEach((form) => {
    if (form) {
      handleChange(form);

      form.addEventListener('change', () => {
        handleChange(form);
      });
    }
  });
});
